import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ContactCallout } from '../components/ContactCallout';
import { ServiceCard } from '../components/ServiceCard';
import { services } from '../data/services';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 18
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55
    }
  }
};
export function HomePage() {
  return <>
      <main data-id="element-188" data-mp="2s2qq2bfnb174">
        <section className="overflow-hidden bg-[#f8f7f3] px-5 pb-20 pt-14 sm:px-8 sm:pb-24 sm:pt-20 lg:px-10 lg:pb-28" aria-labelledby="home-heading" data-id="element-189" data-mp="2s38ys7jhv7vx">
          <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-[1.04fr_0.96fr] lg:gap-16" data-id="element-190" data-mp="31ytuxp1vtdxr">
            <motion.div initial="hidden" animate="show" transition={{
            staggerChildren: 0.1
          }} data-id="element-191" data-mp="2e8gbuo19ypfb">
              <motion.p variants={fadeUp} className="text-xs font-bold uppercase tracking-[0.17em] text-[#286151]" data-id="element-192" data-mp="2antq4kf867ab">
                Independent CRM specialist
              </motion.p>
              <motion.h1 variants={fadeUp} id="home-heading" className="mt-5 max-w-3xl text-5xl font-semibold leading-[0.98] tracking-[-0.045em] text-[#172820] sm:text-6xl lg:text-7xl" style={{
              fontFamily: 'var(--font-display)'
            }} data-id="element-193" data-mp="2jj9uhvdlw4u5">
                Make your CRM the clearest part of your business.
              </motion.h1>
              <motion.p variants={fadeUp} className="mt-7 max-w-xl text-lg leading-8 text-stone-600" data-id="element-194" data-mp="25qbh6u17js2b">
                Daanish designs the CRM integrations, workflows, and lead
                signals that give revenue teams a dependable place to work from.
              </motion.p>
              <motion.div variants={fadeUp} className="mt-9 flex flex-col items-start gap-3 sm:flex-row sm:items-center" data-id="element-195" data-mp="2rfi9sjlv3ggi">
                <Link to="/services/crm-integrations" className="group inline-flex items-center gap-2 rounded-sm bg-[#172820] px-5 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#286151] focus:outline-none focus:ring-2 focus:ring-[#286151] focus:ring-offset-2" data-id="element-196" data-mp="31fiwmfixwepg">
                  Explore CRM integrations{' '}
                  <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-197" data-mp="2ig4yrmi3ajto" />
                </Link>
                <Link to="/contact" className="inline-flex items-center gap-2 px-2 py-3 text-sm font-semibold text-[#286151] underline decoration-[#9bc6b5] underline-offset-4 transition-colors hover:text-[#172820] focus:outline-none focus:ring-2 focus:ring-[#286151]" data-id="element-198" data-mp="1pzki3w4zt0gu">
                  Start a discovery call
                </Link>
              </motion.div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.25,
            duration: 0.65
          }} className="relative mx-auto w-full max-w-xl border border-stone-300 bg-white p-4 shadow-[10px_10px_0_0_#dceee7] sm:p-5" aria-label="Illustration of a connected customer workflow" data-id="element-199" data-mp="3mqydl6gj9c2c">
              <div className="flex items-center justify-between border-b border-stone-200 pb-4" data-id="element-200" data-mp="ec6h3ll73xf5">
                <div className="flex gap-1.5" data-id="element-201" data-mp="2v0tvxfk5r34t">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#c9785d]" data-id="element-202" data-mp="2z0kqluct23em" />
                  <span className="h-2.5 w-2.5 rounded-full bg-[#e4bf70]" data-id="element-203" data-mp="3f775jhulw38j" />
                  <span className="h-2.5 w-2.5 rounded-full bg-[#77aa95]" data-id="element-204" data-mp="3f9jtqcqyj9u1" />
                </div>
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-stone-400" data-id="element-205" data-mp="3aensqn3qtc4s">
                  Customer flow
                </span>
              </div>
              <div className="mt-5 grid grid-cols-[1fr_auto_1fr] items-center gap-3 sm:gap-5" data-id="element-206" data-mp="30k5mpbaut4ht">
                <div className="space-y-3" data-id="element-207" data-mp="1zm4pa7ppi9s">
                  <div className="border border-stone-200 p-3" data-id="element-208" data-mp="3t78gjq4l4r1q">
                    <p className="text-[10px] font-bold uppercase tracking-wider text-stone-400" data-id="element-209" data-mp="3t81ga754mgad">
                      Source
                    </p>
                    <p className="mt-1 text-sm font-semibold text-[#172820]" data-id="element-210" data-mp="3k7395fze5snk">
                      Website enquiry
                    </p>
                  </div>
                  <div className="border border-stone-200 p-3" data-id="element-211" data-mp="2cqvtzop1e2v3">
                    <p className="text-[10px] font-bold uppercase tracking-wider text-stone-400" data-id="element-212" data-mp="28qlp6fczdiht">
                      Source
                    </p>
                    <p className="mt-1 text-sm font-semibold text-[#172820]" data-id="element-213" data-mp="saxrm5xkch4v">
                      Sales notes
                    </p>
                  </div>
                </div>
                <div className="flex flex-col items-center gap-6 text-[#5a9c82]" data-id="element-214" data-mp="x7xygj28lnx1">
                  <ArrowRightIcon className="h-4 w-4" data-id="element-215" data-mp="122bywzvral8k" />
                  <ArrowRightIcon className="h-4 w-4" data-id="element-216" data-mp="170df9d1ss6gc" />
                </div>
                <div className="border border-[#9bc6b5] bg-[#eaf4ef] p-4" data-id="element-217" data-mp="1byx0fb8khe7n">
                  <p className="text-[10px] font-bold uppercase tracking-wider text-[#286151]" data-id="element-218" data-mp="1c11fmpbx1zn8">
                    Your CRM
                  </p>
                  <p className="mt-2 text-base font-semibold text-[#172820]" data-id="element-219" data-mp="1l04wdmnm22yk">
                    One useful record
                  </p>
                  <div className="mt-4 space-y-2" data-id="element-220" data-mp="3htgbl7xndda6">
                    {['Context captured', 'Owner assigned', 'Next step clear'].map(item => <p key={item} className="flex items-center gap-1.5 text-xs text-[#3e564b]" data-id="element-221" data-mp="oxerogexdhg5">
                        <CheckIcon className="h-3.5 w-3.5 text-[#286151]" aria-hidden="true" data-id="element-222" data-mp="12yhamkamibmu" />
                        {item}
                      </p>)}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="bg-white px-5 py-20 sm:px-8 lg:px-10" aria-labelledby="approach-heading" data-id="element-223" data-mp="1lmmf5tz3u0mp">
          <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20" data-id="element-224" data-mp="1ho6u3vml32bx">
            <div data-id="element-225" data-mp="1vm4x64vgfcc4">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#286151]" data-id="element-226" data-mp="1vjiqe7ge10uy">
                The approach
              </p>
              <h2 id="approach-heading" className="mt-4 text-3xl font-semibold tracking-tight text-[#172820] sm:text-4xl" style={{
              fontFamily: 'var(--font-display)'
            }} data-id="element-227" data-mp="2a8ald8uk9zdg">
                Less CRM theatre. More useful infrastructure.
              </h2>
            </div>
            <div className="border-l border-stone-200 pl-6 sm:pl-10" data-id="element-228" data-mp="1ri2m51tzft2j">
              <p className="max-w-2xl text-xl leading-8 text-stone-700" data-id="element-229" data-mp="1rgrkb7k3kve2">
                The best systems remove uncertainty: what happened, who owns it,
                and what needs to happen next. Every engagement starts with your
                actual operating rhythm—not a template.
              </p>
              <div className="mt-8 flex items-center gap-2 text-sm font-semibold text-[#286151]" data-id="element-230" data-mp="1mgvfj63kszxg">
                <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-231" data-mp="18lb5z19qlu2p" /> Built
                around practical adoption
              </div>
            </div>
          </div>
        </section>

        <section className="border-y border-stone-200 bg-[#f8f7f3] px-5 py-20 sm:px-8 lg:px-10" aria-labelledby="services-heading" data-id="element-232" data-mp="1szjdxzq7zt4x">
          <div className="mx-auto max-w-7xl" data-id="element-233" data-mp="1j1bxdhzufd3g">
            <div className="max-w-2xl" data-id="element-234" data-mp="1j47y1e32sfvl">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#286151]" data-id="element-235" data-mp="1e3k0e9kcd0se">
                Ways I can help
              </p>
              <h2 id="services-heading" className="mt-4 text-3xl font-semibold tracking-tight text-[#172820] sm:text-4xl" style={{
              fontFamily: 'var(--font-display)'
            }} data-id="element-236" data-mp="1a2rn958cmbqu">
                A better system, from connection to conversion.
              </h2>
            </div>
            <div className="mt-10 grid gap-4 lg:grid-cols-3" data-id="element-237" data-mp="qdpopvbrdi9q">
              {services.map((service, index) => <ServiceCard key={service.slug} service={service} featured={index === 0} data-id="element-238" data-mp="md5nogo2duib" data-mpi={index} />)}
            </div>
          </div>
        </section>
      </main>
      <ContactCallout data-id="element-239" data-mp="322nqcfvxlv2z" />
    </>;
}